import { UsersInterface } from '../users';
import { TicketSaleQuantityInformationInterface } from './ticket-sale-quantity-information.interface';

export interface UserTicketCollapsedByUserInterface {
  user: UsersInterface;
  ticketSaleInformation: TicketSaleQuantityInformationInterface[];
}
